import React from 'react';
import { TooltipProps } from 'recharts';
import { Box, Typography } from '@mui/material';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

export const CustomTooltip = ({ active, payload, label }: TooltipProps<ValueType, NameType>) => {
  if (active && payload && payload.length) {
    const formattedLabel = new Date(label).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
    });

    return (
      <Box bgcolor="background.paper" border="1px solid" borderColor="border.default" p={1}>
        <Typography variant="subtitle2">{formattedLabel}</Typography>

        {payload.map((entry, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Typography key={index} variant="body2">
            {entry.name}: {`${entry.value}`}
          </Typography>
        ))}
      </Box>
    );
  }
  return null;
};
